import { useState } from "react";

import { useLocationsAll } from "features/locations/hooks/useLocationsAll";
import { useSetDefaultLocation } from "features/locations/hooks/useSetDefaultLocation";
import { DeleteLocationModal } from "features/locations/modals/DeleteLocationModal";
import { LocationFormModal } from "features/locations/modals/LocationFormModal";
import { LocationsTable } from "features/locations/tables/LocationsTable/LocationsTable";

const LocationsPage = () => {
  const { data: locations = [], isLoading } = useLocationsAll();
  const { mutate: setDefault } = useSetDefaultLocation();

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const activeCount = locations.filter((l) => !l.disabled).length;

  const handleAdd = () => {
    setSelectedLocation(null);
    setIsAddOpen(true);
  };

  const handleEdit = (location) => {
    setSelectedLocation(location);
    setIsEditOpen(true);
  };

  const handleDelete = (location) => {
    setSelectedLocation(location);
    setIsDeleteOpen(true);
  };

  const handleSetDefault = (location) => {
    setDefault(location.id);
  };

  return (
    <div>
      <LocationsTable
        locations={locations}
        isLoading={isLoading}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onSetDefault={handleSetDefault}
      />

      <LocationFormModal
        isOpen={isAddOpen}
        onClose={() => setIsAddOpen(false)}
        isOnlyLocation={activeCount === 0}
      />

      <LocationFormModal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        location={selectedLocation}
        isOnlyLocation={activeCount === 1 && !selectedLocation?.disabled}
      />

      <DeleteLocationModal
        isOpen={isDeleteOpen}
        onClose={() => setIsDeleteOpen(false)}
        location={selectedLocation}
      />
    </div>
  );
};

export { LocationsPage };
